<template>
  <b-badge v-bind="variant">
    {{ expiredAt | toEndOfDayFromNow }}
    <span v-if="showDate">
      | {{ expiredAt | dateFormat }}
    </span>
  </b-badge>
</template>
<script>

export default {
  computed: {
    percentage() {
      const total = this.$moment(this.expiredAt).endOf('day').diff(
        this.$moment(this.createdAt).startOf('day')
      );
      const current = this.$moment().diff(this.$moment(this.createdAt));
      const percentage = (current * 100) / total;
      return Math.round((percentage + Number.EPSILON) * 100) / 100;
    },
    variant() {
      const { percentage } = this;
      if (percentage >= 80) {
        return {
          variant: 'light-danger',
          class: 'activity-alive-badge-danger',
          style: { '--activity-alive-percentage': `${percentage}%` }
        };
      }
      if (percentage >= 60) {
        return {
          variant: 'light-warning',
          class: 'activity-alive-badge-warning',
          style: { '--activity-alive-percentage': `${percentage}%` }
        };
      }
      if (percentage >= 50) {
        return {
          variant: 'light-info',
          class: 'activity-alive-badge-info',
          style: { '--activity-alive-percentage': `${percentage}%` }
        };
      }
      return {
        variant: 'light-success',
        class: 'activity-alive-badge-success',
        style: { '--activity-alive-percentage': `${percentage}%` }
      };
    }
  },
  props: {
    createdAt: { type: String, required: true },
    expiredAt: { type: String, required: true },
    showDate: { type: Boolean, default: false }
  }
};

</script>
<style lang="scss" scoped>

@import '~@core/scss/base/core/colors/palette-variables.scss';

@each $color_name, $color in $colors {
  @each $color_type, $color_value in $color {
    @if $color_type == 'base' {

      .activity-alive-badge-#{$color_name} {
        position: relative;
        border-bottom: 5px solid transparent;

        &:before {
          content: '';
          position: absolute;
          height: 5px;
          right: 0;
          bottom: -5px;
          left: 0;
          border-bottom-right-radius: inherit;
          border-bottom-left-radius: inherit;

          $percentage-color: $color_value;
          $base-color: rgba($secondary, .12);
          background: linear-gradient(
              to right,
              $percentage-color,
              $percentage-color var(--activity-alive-percentage, 0),
              $base-color var(--activity-alive-percentage, 0),
              $base-color
          );
        }
      }
    }
  }
}

</style>
